import React, { useState } from "react";
import { Form, Container } from "react-bootstrap";
import "./Change_USDT_Address.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import { faCamera, faUpload, faCloudUploadAlt, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useForm } from "react-hook-form";
import Successfull_strip_modal from "../Common/Common_Component/Common_Modal/Successfull_strip_modal/Successfull_strip_modal";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { SubmitChangeUSDTAddress } from "../../features/support/slice";

const uploadFields = [
  { id: "old_usdt_address_screenshot", label: "Old USDT Address Screenshot", mandatory: true, accept: "image/*" },
  { id: "new_usdt_address_screenshot", label: "New USDT Address Screenshot", mandatory: true, accept: "image/*" },
  { id: "identity_card", label: "Identity Card", mandatory: true, accept: "*/*" },
  { id: "passbook_digital_banking", label: "Passbook / Digital Banking", mandatory: true, accept: "*/*" },
  { id: "latest_deposit_receipt_1", label: "Latest Deposit Receipt 1", mandatory: true, accept: "*/*" },
  { id: "latest_deposit_receipt_2", label: "Latest Deposit Receipt 2", mandatory: true, accept: "*/*" },
  {
    id: "video_holding",
    label:
      "Video holding : Identity Card, Passbook, Old USDT Address and Piece of paper with today's date written on it",
    mandatory: true,
    isFile: true,
    accept: "video/*",
  },
];

const requiredFileIds = [
  "old_usdt_address_screenshot",
  "new_usdt_address_screenshot",
  "identity_card",
  "passbook_digital_banking",
  "latest_deposit_receipt_1",
  "latest_deposit_receipt_2",
  "video_holding",
];

function Change_USDT_Address() {

  const {
    register, getValues,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const [modalShow, setModalShow] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [files, setFiles] = useState({
    old_usdt_address_screenshot: null,
    new_usdt_address_screenshot: null,
    identity_card: null,
    passbook_digital_banking: null,
    latest_deposit_receipt_1: null,
    latest_deposit_receipt_2: null,
    video_holding: null,
  });

  const [previews, setPreviews] = useState({
    old_usdt_address_screenshot: null,
    new_usdt_address_screenshot: null,
    identity_card: null,
    passbook_digital_banking: null,
    latest_deposit_receipt_1: null,
    latest_deposit_receipt_2: null,
    video_holding: null,
  });

  const [fileErrors, setFileErrors] = useState({});

  const handleFileChange = (e, key) => {
    const file = e.target.files[0];
    if (!file) return;

    setFiles((prev) => ({
      ...prev,
      [key]: file,
    }));

    setPreviews((prev) => ({
      ...prev,
      [key]: file.type.startsWith("image") || file.type.startsWith("video")
        ? URL.createObjectURL(file)
        : "file_uploaded",
    }));

    setFileErrors((prev) => ({
      ...prev,
      [key]: null,
    }));

    e.target.value = "";

  };

  const validateFiles = () => {
    const newErrors = {};

    requiredFileIds.forEach((id) => {
      if (!files[id]) {
        const field = uploadFields.find((f) => f.id === id);
        newErrors[id] = `${field?.label} is required`;
      }
    });

    setFileErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const onSubmit = async (data) => {

    if (!validateFiles()) return;

    const formData = new FormData();

    formData.append("user_uid", data.user_uid.trim());
    formData.append("old_usdt_address", data.old_usdt_address.trim());
    formData.append("new_usdt_address", data.new_usdt_address.trim());

    Object.entries(files).forEach(([key, file]) => {
      if (file) formData.append(key, file);
    });

    const res = await dispatch(SubmitChangeUSDTAddress(formData));

    if (res.meta?.requestStatus === "fulfilled") {
      setModalMessage(res?.payload?.data || "Bank Information Modified Successfully");
      setModalShow(true);
      reset();
      setFiles(Object.fromEntries(Object.keys(files).map((k) => [k, null])));
      setPreviews(Object.fromEntries(Object.keys(previews).map((k) => [k, null])));
      setFileErrors({});
      setTimeout(() => {
        setModalShow(false);
        navigate(-1);
      }, 2000);
    } else {
      setModalMessage(
        res?.payload?.errors || "Submission failed. Please try again"
      );
      setModalShow(true);
      setTimeout(() => setModalShow(false), 3000);
    }
  };

  return (
    <>
      <section className="Change_USDT_Address_Wrapper Modify_Bank_Information">
        <Common_white_header headingText={"Change USDT Address"} />

        <Container>
          <Form className="mt-3" onSubmit={handleSubmit(onSubmit)} noValidate>

            {/* Daman ID */}
            <Form.Group className="form-group field_holder">
              <Form.Label>
                Money King ID <span className="mandatory_estrics">*</span>
              </Form.Label>

              <Form.Control
                type="text"
                placeholder="Please enter User ID"
                onInput={(e) =>
                  (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                }
                {...register("user_uid", {
                  required: "Money King ID is required",
                  pattern: {
                    value: /^[0-9]+$/,
                    message: "Only numbers allowed",
                  },
                })}
              />

              {errors.user_uid && (
                <small className="text-danger">
                  {errors.user_uid.message}
                </small>
              )}
            </Form.Group>


            {/* OLD USDT */}
            <Form.Group className="form-group field_holder">
              <Form.Label>
                Old USDT Address <span className="mandatory_estrics">*</span>
              </Form.Label>

              <Form.Control
                type="text"
                placeholder="Please enter content"
                {...register("old_usdt_address", {
                  required: "Old USDT Address is required",
                  pattern: {
                    value: /^(T[1-9A-HJ-NP-Za-km-z]{33}|0x[a-fA-F0-9]{40})$/,
                    message: "Enter a valid USDT wallet address",
                  },
                  validate: (value) =>
                    value !== getValues("new_usdt_address") ||
                    "Old and New USDT address cannot be the same",
                })}
              />

              {errors.old_usdt_address && (
                <small className="text-danger">
                  {errors.old_usdt_address.message}
                </small>
              )}
            </Form.Group>


            {/* NEW USDT */}
            <Form.Group className="form-group field_holder">
              <Form.Label>
                New USDT Address <span className="mandatory_estrics">*</span>
              </Form.Label>

              <Form.Control
                type="text"
                placeholder="Please enter content"
                {...register("new_usdt_address", {
                  required: "New USDT Address is required",
                  pattern: {
                    value: /^(T[1-9A-HJ-NP-Za-km-z]{33}|0x[a-fA-F0-9]{40})$/,
                    message: "Enter a valid USDT wallet address",
                  },
                  validate: (value) =>
                    value !== getValues("old_usdt_address") ||
                    "Old and New USDT address cannot be the same",
                })}
              />

              {errors.new_usdt_address && (
                <small className="text-danger">
                  {errors.new_usdt_address.message}
                </small>
              )}
            </Form.Group>


            {uploadFields.map((item) => (
              <Form.Group className="form-group field_holder" key={item.id}>
                <Form.Label>
                  {item.label}{" "}
                  {item.mandatory && (
                    <span className="mandatory_estrics">*</span>
                  )}
                </Form.Label>

                <div className="upload_box">
                  <input
                    type="file"
                    id={item.id}
                    hidden
                    accept={item.accept}
                    onChange={(e) => handleFileChange(e, item.id)}
                  />

                  <label htmlFor={item.id} className="photo_label">
                    {previews[item.id] && (
                      <div className="close-btn">
                        <FontAwesomeIcon
                          icon={faXmark}
                          onClick={(e) => {
                            // e.stopPropagation();
                            e.preventDefault();  // extra safety
                            setPreviews((prev) => ({
                              ...prev,
                              [item.id]: null,
                            }));
                          }}
                        />
                      </div>
                    )}
                    {previews[item.id] &&
                      previews[item.id] !== "file_uploaded" ? (

                      item.accept?.includes("video") ? (
                        <video
                          src={previews[item.id]}
                          className="uploaded_img_preview"
                          controls
                        />
                      ) : (
                        <img
                          src={previews[item.id]}
                          alt="Preview"
                          className="uploaded_img_preview"
                        />
                      )

                    ) : previews[item.id] === "file_uploaded" ? (
                      <div className="success_upload">
                        <FontAwesomeIcon
                          icon={faCloudUploadAlt}
                          style={{ color: "#28a745" }}
                        />
                        <span>Uploaded</span>
                      </div>

                    ) : (
                      <>
                        <FontAwesomeIcon icon={item.isFile ? faUpload : faCamera} />
                        <span>{item.isFile ? "Upload" : "Photo"}</span>
                      </>
                    )}
                  </label>
                </div>

                {fileErrors[item.id] && (
                  <small className="text-danger">
                    {fileErrors[item.id]}
                  </small>
                )}
              </Form.Group>
            ))}

            <button
              type="submit"
              className="btn_register_bg"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Submitting..." : "Confirm"}
            </button>

          </Form>
        </Container>
        <Successfull_strip_modal
          show={modalShow}
          onHide={() => setModalShow(false)}
          textMsg={modalMessage}
        />
      </section>
    </>
  );
}

export default Change_USDT_Address;